export default function LevelIcon({ level, ...props }) {
    const src = {
        4: '/images/levels/platinum.svg',
        3: '/images/levels/gold.svg',
        2: '/images/levels/silver.svg',
        1: '/images/levels/bronze.svg',
    }[level] || '/images/levels/unknown.svg';

    return <img src={src} alt="" {...props} />;
}
